module.exports = __webpack_public_path__ + "img/yxlnm_Android.b3fe4baf.png";